import React from "react";
import { Buttons } from "@danishagro/cms/src/components/Buttons/Buttons.component";
import { cn } from "@danishagro/shared/src/helpers/classNames.helper";
import { DA_Text } from "@danishagro/shared/src/components/atoms/Text/Text.component";
import {
    DA_Title,
    DA_TitleTag,
} from "@danishagro/shared/src/components/atoms/Title/Title.component";
import { DA_Tag } from "@danishagro/shared/src/components/atoms/Tag/Tag.component";
import { ImageViewer } from "@danishagro/cms/src/components/ImageViewer/ImageViewer.component";
import { useProductTracker } from "@danishagro/shared/src/gtm/useProductsTracker";
import { useNavigate } from "react-router-dom";
import { CardProps } from "./Card.interface";
import S from "./Card.module.scss";

const Card = (props: CardProps) => {
    const navigate = useNavigate();

    // GTM tracking content list links
    const trackProductClick = useProductTracker({
        ...props,
        price: "",
        currency: "",
        quantity: 0,
        category: "",
        name: props.headline,
        brand: "",
        productNumber: "",
    });

    const onLinkClicked = () => {
        if (typeof window !== "undefined") {
            navigate(`${window.location.pathname}${window.location.search}`, {
                replace: true,
                state: {
                    scrollY: document.documentElement.scrollTop || document.body.scrollTop,
                },
            });
        }
        // // GTM Tracking the product click when the link is clicked
        trackProductClick("select_item");
    };
    const aspectRatioOverwrites = props.isPortraitImage
        ? { aspectRatioX: 400, aspectRatioY: 300 }
        : props?.isVerticalImage
        ? { aspectRatioX: 400, aspectRatioY: 300 }
        : { aspectRatioX: 400, aspectRatioY: 200 };

    return (
        <div className={cn(S.wrapper, props.className)}>
            {/** Image */}
            {props.image?.url ? (
                <div className={S.imageWrapper}>
                    <ImageViewer
                        src={props.image.url}
                        className={cn(S.image, {
                            [S.verticalImage]: props.isVerticalImage,
                        })}
                        {...aspectRatioOverwrites}
                        alternative={props.alternative}
                    />
                </div>
            ) : null}

            <div className={S.textWrapper}>
                <div className={S.textInner}>
                    {/* Tag */}
                    {props.tag && (
                        <div className={S.tagWrapper}>
                            <DA_Tag color="good">
                                <span>{props.tag}</span>
                            </DA_Tag>
                        </div>
                    )}

                    {/** Headline */}
                    {props.headline ? (
                        <DA_Title h4 tag={DA_TitleTag.H4} noMargin fullWidth>
                            {props.headline}
                        </DA_Title>
                    ) : null}

                    {/** Text */}
                    {props.text ? <DA_Text html={props.text} noPadding /> : null}
                </div>

                {/** Buttons */}
                <div
                    onClick={onLinkClicked}
                    role="button"
                    onKeyDown={(e) => {
                        if (e.key === "Enter" || e.key === " ") onLinkClicked();
                    }}
                    tabIndex={0}
                >
                    <Buttons buttons={props.buttons} />
                </div>
            </div>
        </div>
    );
};

export default Card;
